module.exports = __webpack_public_path__ + "img/userphoto.08e2a0f5.png";